<template>
  <div>
    <span v-translate>
      Oh no! We are sorry but there are currently no matching jobs available. Check back later.
    </span>
    <div class="file is-centered sad-robot">
      <sad-robot-illustration></sad-robot-illustration>
    </div>
  </div>
</template>

<script>

import SadRobotIllustration from 'top20common/components/illustrations/SadRobotIllustration';
export default {
  components: {SadRobotIllustration}
};
</script>

<styles lang="scss" scoped>
  .sad-robot {
    padding: 28px 0 8px;
  }
</styles>
